import React, { ChangeEvent, Ref, forwardRef } from 'react';

import { Flex, Input } from 'src/packages/core';
import { CalendarIcon, XIcon } from 'src/packages/icons';

import { CustomInputProps } from '../DatePicker.types';

export const CustomInput = forwardRef(
  (
    {
      value,
      className,
      isClearable,
      onClick,
      onChange,
      handleChange,
      defaulttheme,
      ...rest
    }: CustomInputProps,
    ref: Ref<HTMLInputElement>
  ) => {
    //change input value
    const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
      onChange && onChange(e);
    };

    //clear value of input
    const handleClear = () => {
      handleChange(null);
    };

    return (
      <Input
        ref={ref}
        value={value}
        className={`${className}, date-picker-input`}
        onClick={onClick}
        rightElement={
          isClearable && value ? (
            <Flex onClick={handleClear}>
              <XIcon color={defaulttheme.colors.text.primary} size={16} />
            </Flex>
          ) : (
            <CalendarIcon color={defaulttheme.colors.text.primary} size={16} />
          )
        }
        {...rest}
        onChange={handleInputChange}
      />
    );
  }
);
